import { WalletGiftcardIcon } from './WalletGiftcardIcon';

/**
 * author: Google
 * id 0D4DD4F1-0915-4D3D-8F21-A96C2DDAF6E0
 * name wallet-giftcard
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-giftcard.svg
 * tags
 * - Shopping 
 * - Banking 
 */
export const RedeemIcon = WalletGiftcardIcon;
export default RedeemIcon